const LivingBelowChallenge2InitialText ="It can be difficult to ensure that you are " +
    "spending less than you make.  Review the items in the 'Considerations' column " +
    "and determine if it is a good way to live below your means.  If so, drag the item " +
    "to the 'Good Ideas' column. If it is not a good idea for living below your means " +
    "drag the item to the 'Things to Avoid' column. When you are done, click the 'Done' button."

export default LivingBelowChallenge2InitialText 
